// Typelizer digest fbc82ebd5b06569b86ce5655b689b0a2
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** POST /rails/active_storage/direct_uploads */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/rails/active_storage/direct_uploads', {}, options),
    method: 'post',
  }),
}
